import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getAxios } from 'src/lib/axios';

type Settings = {
  GooglePlacesApiKey: string | undefined;
  GoogleAnalyticsKey: string | undefined;
};

const getSettings = async (): Promise<Settings> => {
  const client = getAxios();
  return (await client.get<Settings>(`/api/ObtV2/settings`)).data;
};

type UseSettingsOptions = {
  config?: UseQueryOptions<Settings>;
};

export const useSettings = ({ config }: UseSettingsOptions = {}) => {
  return useQuery({
    ...config,
    queryKey: ['settings'],
    queryFn: () => getSettings()
  });
};
